import { render } from "./RouteView.vue?vue&type=template&id=0c31b45e&scoped=true"
import script from "./RouteView.vue?vue&type=script&lang=js"
export * from "./RouteView.vue?vue&type=script&lang=js"

import "./RouteView.vue?vue&type=style&index=0&id=0c31b45e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c31b45e"]])

export default __exports__